"use client";
import React, { useState } from "react";
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure, Input, Textarea } from "@heroui/react";
import { AlertCircle, CheckCircle } from "lucide-react";

const LeadGenModal = ({ companyName } : { companyName: string }) => {
  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const [formData, setFormData] = useState({ type: 'lead-gen', name: '', email: '', contact: '', message: '' });
  const [successMessage, setSuccessMessage] = useState('');

  const handleChange = (e : React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async () => {
    // Send email using AWS SES
    const response = await fetch('/api/contactus', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      setSuccessMessage('Your enquiry has been sent successfully!');
      setFormData({ type: 'lead-gen', name: '', email: '', contact: '', message: '' });
    } else {
      setSuccessMessage('There was an error sending your enquiry. Please try again.');
    }

    setTimeout(() => {
      setSuccessMessage('');
      onOpenChange();
    }, 3000);
  };

  return (
    <>
      <Button onPress={onOpen} color="primary" size="md" className="whitespace-normal text-center font-semibold text-white w-full min-w-fit sm:w-fit"> 
        Questions for {companyName}?
      </Button>
      <Modal 
        isOpen={isOpen} 
        onOpenChange={onOpenChange}
        placement="top-center"
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">Enquiry Form for {companyName}</ModalHeader>
              <ModalBody>
              {successMessage && (
                  <div className={`flex items-center justify-center p-4 mb-4 text-base font-semibold rounded-lg ${successMessage.includes('successfully') ? 'text-green-700 bg-green-100' : 'text-red-700 bg-red-100'}`}>
                    {successMessage.includes('successfully') ? <CheckCircle className="w-5 h-5 mr-2" /> : <AlertCircle className="w-5 h-5 mr-2" />}
                    {successMessage}
                  </div>
                )}
                <Input
                  autoFocus
                  label="Name"
                  placeholder="John Doe"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  variant="bordered"
                />
                <Input
                  label="Email"
                  placeholder="johndoe@gmail.com"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  variant="bordered"
                />
                <Input
                  label="Contact"
                  placeholder="+65 1234 5678"
                  name="contact"
                  value={formData.contact}
                  onChange={handleChange}
                  variant="bordered"
                />
                <Textarea
                  size="lg"
                  label="Enquiry"
                  placeholder="How can we help you?"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  variant="bordered"
                />
              </ModalBody>
              <ModalFooter>
                <Button color="default" variant="ghost" onPress={onClose}>
                  Close
                </Button>
                <Button color="primary" className="text-white" variant="solid" onPress={handleSubmit}>
                  Submit
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};

export default LeadGenModal;